angular.module('gym.calendar').factory('AppointmentTypes', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('appointment_types');
}]);
